import React, { Component } from 'react';
import logonemaliname from '../resources/images/logo_nemali_horizontal.png';
/**
* Class Accueil
* Accueil component
**/
class Accueil extends Component {

  /**
  * componentWillMount
  * TODO : Load HTML from here
  **/
  componentWillMount() {}

  /**
  * render
  * Rendering component function : display the homepage
  **/
  render() {
    return(
      <div className="Accueil">
        <h2>Accueil</h2>

        <div style={{margin: "50px"}}>
          {/* <p>Port généraliste, Guadeloupe Port Caraïbes traite une grande diversité de trafics (passagers, marchandises, nautisme) et anime une place portuaire compétitive et diversifiée.</p>
          <p>
            Dans le cadre de la politique générale établie par le Gouvernement, il a pour mission d’assurer la gestion des installations portuaires et les accès maritimes des ports situés dans sa circonscription.
            Celle-ci se compose de cinq sites spécialisés, répartis sur  l’archipel, contribuant à l’aménagement et à l’équilibre du territoire :
          </p>
          <ul>
            <li>le port de Jarry à Baie-Mahault,</li>
            <li>le port de Pointe-à-Pitre,</li>
            <li>le port de Basse-Terre,</li>
            <li>le port de Folle Anse à Marie-Galante,</li>
            <li>le port de plaisance de Bas-du-Fort (mis en concession depuis le 1er janvier 2006).</li>
          </ul>
          <p>
            Guadeloupe Port Caraïbes est chargé, à l’intérieur des limites de cette circonscription, des travaux d’extension, d’amélioration, de renouvellement, de reconstruction, ainsi que de l’exploitation,
            de l’entretien et de la police des ports, et de la gestion et l’aménagement du domaine immobilier et foncier qui lui est affecté.
          </p> */}

          <center><img src={logonemaliname} className="App-logo-gpmg-name-acceuil" alt="logonemaliname" /></center>
          {/* <p>
            Sources :
          </p>
          <ul>
            <li><a href="http://guadeloupe-portcaraibes.com/qui-sommes-nous.html" target="_blank">http://guadeloupe-portcaraibes.com/qui-sommes-nous.html</a></li>
            <li><a href="http://guadeloupe-portcaraibes.com/fr/qui-sommes-nous/nos-missions.html" target="_blank">http://guadeloupe-portcaraibes.com/fr/qui-sommes-nous/nos-missions.html</a></li>
          </ul> */}
        </div>
      </div>
    );
  }
}

export default Accueil;



// WEBPACK FOOTER //
// ./src/views/Accueil.js